module.exports = __webpack_public_path__ + "img/item_2.0a92dc61.jpg";